<div class="accordion" id="hierarchyAccordion" [class.no-frame]="!showFrame">
  <div class="accordion-item">
    <div class="accordion-header" [hidden]="!showFrame">
      <h2>
        <button type="button" class="clickable-title" (click)="onTitleClick()">
          @if (hierarchyLevel !== undefined) {
          <i class="bi bi-{{ hierarchyLevel }}-circle-fill"></i>
          }
          {{ parentTitle | abpLocalization }}
        </button>
      </h2>

      <button class="accordion-button" [class.collapsed]="!isExpanded" type="button" (click)="toggleAccordion()"
        [attr.aria-expanded]="isExpanded" aria-controls="collapseOne">
      </button>
    </div>
    @if (!isExpanded) {
    <ul class="summary-list">
      @for (item of getSummaryItems(); track item.label) {
      <li>
        <p>{{ item.label | abpLocalization }} <strong>{{ item.value }}</strong></p>
      </li>
      }
    </ul>
    }


    <div id="collapseOne" class="accordion-collapse" [class.show]="isExpanded || !showFrame"
      [class.collapsed]="showFrame && !isExpanded">
      <div class="accordion-body" [class.no-padding]="!showFrame">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
